module.exports = __webpack_public_path__ + "media/zingal.486df619.mp4";